import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getHomeData = createAsyncThunk("data/home", async () => {
  try {
    const response = await fetch(
      "https://webtrans.developer-ourbase-camp.com/api/home"
    );
    const fetchedData = await response.json();
    return fetchedData;
  } catch (error) {
    throw error;
  }
});

export const homeSlice = createSlice({
  name: "home",
  initialState: {
    isLoading: false,
    isError: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHomeData.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getHomeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getHomeData.rejected, (state, action) => {
        state.isError = action.payload;
        state.isLoading = true;
      });
  },
});

export default homeSlice.reducer;

export const getData = (state) => state?.home?.data;
export const getLoadingState = (state) => state?.home?.isLoading;
export const getError = (state) => state?.home?.isError;
